import { render, staticRenderFns } from "./RealmIdea.vue?vue&type=template&id=e0297242"
import script from "./RealmIdea.vue?vue&type=script&lang=js"
export * from "./RealmIdea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports